import { Injectable } from '@angular/core';

import { setInitialStoreState } from '../../../../../common/utils';
import { PlantOptionsFacade } from './plant-options.facade';

@Injectable({
  providedIn: 'root',
})
export class PlantOptionsGuard  {
  constructor(private plantOptionsFacade: PlantOptionsFacade) {}

  canDeactivate(): boolean {
    return setInitialStoreState(this.plantOptionsFacade);
  }
}
